import React, { Component } from "react";
import { Empty, Tag } from "antd";
import { SwapOutlined, SendOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import { ModalItem, MensajeError } from "../../../../Components/Items";

class ModalHistorialEntregasOrden extends Component {
  state = { loading: false, historial: [] };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) this.consultarHistorial();
  }

  consultarHistorial = () => {
    if (!this.props.ordenId || !this.props.empresaId) {
      return MensajeError({
        message: `No se pudo cargar el historial: falta ${!this.props.ordenId ? "ordenId" : "empresaId"} (revisar cómo se abrió este modal)`,
      });
    }
    this.setState({ loading: true });
    axios
      .post("almacen/historialEntregasOrden", { ordenId: this.props.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ historial: res.data.historial || [] });
        } else {
          MensajeError({ message: res.data.error || "No se pudo cargar el historial" });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  render() {
    const { visible, onCerrar } = this.props;
    const { loading, historial } = this.state;

    return (
      <ModalItem title="Historial de entregas a esta orden" visible={visible} spinning={loading} onCancel={onCerrar} width="55%" paddingTop footer={null}>
        {historial.length === 0 ? (
          <Empty description="Todavía no se le ha entregado material a esta orden" />
        ) : (
          historial.map((item) => (
            <div
              key={item._id}
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                padding: "10px 14px",
                marginBottom: 10,
                opacity: item.cancelado ? 0.5 : 1,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                <div>
                  {item.tipo === "traspaso" ? (
                    <Tag color="blue" icon={<SwapOutlined />}>
                      Traspaso
                    </Tag>
                  ) : (
                    <Tag color="orange" icon={<SendOutlined />}>
                      Requisición
                    </Tag>
                  )}
                  <b>{item.folio}</b>
                  {item.cancelado && (
                    <Tag color="red" style={{ marginLeft: 6 }}>
                      Cancelado
                    </Tag>
                  )}
                </div>
                <div style={{ fontSize: 12, color: "#999" }}>
                  {moment(item.fecha).format("DD/MM/YYYY HH:mm")}
                  {item.usuarioNombre ? ` — ${item.usuarioNombre}` : ""}
                </div>
              </div>
              <div style={{ marginTop: 8 }}>
                {item.insumos.map((insumo) => (
                  <div key={insumo.insumoId} style={{ fontSize: 13, display: "flex", justifyContent: "space-between" }}>
                    <span>
                      {insumo.clave ? insumo.clave + " - " : ""}
                      {insumo.descripcion}
                    </span>
                    <b>
                      {insumo.cantidad} {insumo.unidad}
                    </b>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalHistorialEntregasOrden);
